const RANKING_ITEMS = [
  { rank: 1, title: '某顶流艺人私生活大起底：圈内人匿名爆料细节惊人', views: '128万', trend: 'up', hot: true },
  { rank: 2, title: '年度最大反转：被骂三年的艺人原来一直在默默做公益', views: '156万', trend: 'up', hot: true },
  { rank: 3, title: '直播带货界又出大事！头部主播涉嫌虚假宣传被实名举报', views: '96万', trend: 'up', hot: true },
  { rank: 4, title: '综艺节目录制现场突发冲突，节目组紧急叫停引热议', views: '85万', trend: 'up', hot: false },
  { rank: 5, title: '深度调查：娱乐圈资本游戏背后的灰色利益链条', views: '72万', trend: 'down', hot: false },
  { rank: 6, title: '某女星被曝隐婚三年，孩子已两岁？知情人晒多张照片', views: '45.6万', trend: 'up', hot: false },
  { rank: 7, title: '带货一哥被税务部门约谈？直播间突然停播引网友猜测', views: '38.2万', trend: 'up', hot: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            黑料排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时更新的吃瓜热度排行榜，看看今天什么瓜最火
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-lg bg-background-50 border border-background-200/60 overflow-hidden">
            {RANKING_ITEMS.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 p-4 md:p-5 ${
                  idx < RANKING_ITEMS.length - 1 ? 'border-b border-background-200/60' : ''
                } hover:bg-background-100 transition-colors cursor-pointer`}
              >
                <div className={`w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full font-heading text-sm md:text-base shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-400 text-background-50'
                    : item.rank === 3
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <p className="text-sm md:text-base text-foreground-800 font-medium truncate">
                      {item.title}
                    </p>
                    {item.hot && (
                      <span className="inline-flex items-center gap-0.5 px-1.5 py-0.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium whitespace-nowrap shrink-0">
                        <i className="ri-fire-line text-[10px]"></i>热
                      </span>
                    )}
                  </div>
                </div>

                <div className="flex items-center gap-4 shrink-0">
                  <div className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className={`${
                      item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-arrow-down-line text-foreground-400'
                    }`}></i>
                  </div>
                  <span className="text-xs md:text-sm font-medium text-foreground-700 whitespace-nowrap">
                    <i className="ri-eye-line mr-1"></i>{item.views}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}